import React from 'react';

const OfferLandingPage = ({
  title,
  body,
  backgroundImage,
  actionButton,
  themeColors,
  isModal = false,
  onClose,
}) => {
  const containerStyle = {
    minHeight: isModal ? 'auto' : '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1,
  };

  const contentStyle = {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    maxWidth: '900px',
    textAlign: 'center',
    color: 'white',
    padding: '40px 20px',
    borderRadius: '20px',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(15px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5)',
    margin: '0 10px',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: 'rgba(255, 255, 255, 0.2)',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    transition: 'all 0.3s ease',
    zIndex: 3,
  };

  const closeButtonHoverStyle = {
    background: 'rgba(255, 255, 255, 0.3)',
    transform: 'scale(1.1)',
  };

  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: '700',
    marginBottom: '20px',
    lineHeight: '1.2',
    textShadow: '3px 3px 6px rgba(0, 0, 0, 0.8)',
    color: '#ffffff',
  };

  const bodyStyle = {
    fontSize: '1rem',
    lineHeight: '1.6',
    marginBottom: '30px',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
    color: '#ffffff',
    maxWidth: '700px',
    margin: '0 auto 30px auto',
    whiteSpace: 'pre-line',
  };

  const buttonGradientStart = themeColors?.button_gradient_start || '#000000';
  const buttonGradientEnd = themeColors?.button_gradient_end || '#333333';
  const buttonTextColor = themeColors?.button_text || '#ffffff';

  const buttonStyle = {
    display: 'inline-block',
    padding: '14px 28px',
    fontSize: '1rem',
    fontWeight: '600',
    color: buttonTextColor,
    background: `linear-gradient(135deg, ${buttonGradientStart}, ${buttonGradientEnd})`,
    border: 'none',
    borderRadius: '8px',
    textDecoration: 'none',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    transition: 'all 0.3s ease',
    boxShadow: `0 10px 30px rgba(0, 0, 0, 0.3)`,
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
  };

  const buttonHoverStyle = {
    transform: 'translateY(-2px)',
    boxShadow: `0 15px 40px rgba(0, 0, 0, 0.4)`,
  };

  const [isHovered, setIsHovered] = React.useState(false);
  const [isCloseHovered, setIsCloseHovered] = React.useState(false);

  const handleButtonClick = () => {
    if (actionButton.link) {
      window.open(actionButton.link, '_blank');
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (isModal && e.target === e.currentTarget) {
      handleClose();
    }
  };

  const content = (
    <div style={containerStyle} onClick={handleBackdropClick}>
      <div style={overlayStyle}></div>
      <div style={contentStyle}>
        {isModal && onClose && (
          <button
            style={{
              ...closeButtonStyle,
              ...(isCloseHovered ? closeButtonHoverStyle : {}),
            }}
            onMouseEnter={() => setIsCloseHovered(true)}
            onMouseLeave={() => setIsCloseHovered(false)}
            onClick={handleClose}
            aria-label="Close modal"
          >
            ×
          </button>
        )}
        {title && <h1 style={titleStyle}>{title}</h1>}
        {body && <p style={bodyStyle}>{body}</p>}
        {actionButton.name && (
          <button
            style={{
              ...buttonStyle,
              ...(isHovered ? buttonHoverStyle : {}),
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleButtonClick}
          >
            {actionButton.name}
          </button>
        )}
      </div>
    </div>
  );

  if (isModal) {
    const modalOverlayStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px',
    };

    const modalContentStyle = {
      width: '100%',
      maxWidth: '90vw',
      maxHeight: '95vh',
      overflow: 'auto',
      borderRadius: '20px',
    };

    return (
      <div style={modalOverlayStyle} onClick={handleBackdropClick}>
        <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
          {content}
        </div>
      </div>
    );
  }

  return content;
};

export default OfferLandingPage;
